var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "div",
      {
        staticClass: "modal",
        class: _vm.value ? "show" : "hide",
        style: _vm.value
          ? "display:block;background-color:#3333337a;"
          : "display:none;",
        attrs: { tabindex: "-1", role: "dialog", "aria-hidden": "true" }
      },
      [
        _c(
          "div",
          {
            staticClass:
              "modal-dialog modal-dialog-centered modal-dialog-scrollable",
            attrs: { role: "document" }
          },
          [
            _c("div", { staticClass: "modal-content" }, [
              _c(
                "div",
                {
                  staticClass: "modal-header d-flex flex-row align-items-center"
                },
                [
                  _c("h3", [
                    _vm._v(" Commande #" + _vm._s(_vm.row_no.no_id) + " ")
                  ])
                ]
              ),
              _c("div", { staticClass: "modal-body" }, [
                _vm.editionMode
                  ? _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        { staticClass: "col col-lg-7" },
                        [
                          _c("h4", [_vm._v("Mettre à jour le statut")]),
                          _c("m-form-select", {
                            attrs: {
                              label: "Nouveau statut",
                              "label-position": "top",
                              items: _vm.$store.state.items_no_statuses
                            },
                            model: {
                              value: _vm.status,
                              callback: function($$v) {
                                _vm.status = $$v
                              },
                              expression: "status"
                            }
                          }),
                          _vm.status !== "ORDER_SENT"
                            ? _c(
                                "div",
                                [
                                  _c("m-form-text", {
                                    attrs: {
                                      rows: 8,
                                      label: "Commentaire",
                                      type: "textarea"
                                    },
                                    model: {
                                      value: _vm.comment,
                                      callback: function($$v) {
                                        _vm.comment = $$v
                                      },
                                      expression: "comment"
                                    }
                                  }),
                                  _vm.commentError
                                    ? _c(
                                        "div",
                                        { staticClass: "text-danger" },
                                        [_vm._v(_vm._s(_vm.commentError))]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            : _c(
                                "div",
                                [
                                  _c("m-form-date", {
                                    attrs: { label: "Date de l'envoi" },
                                    model: {
                                      value: _vm.pa_date,
                                      callback: function($$v) {
                                        _vm.pa_date = $$v
                                      },
                                      expression: "pa_date"
                                    }
                                  }),
                                  _c("m-form-select", {
                                    attrs: {
                                      label: "Société de Livraison",
                                      items: _vm.$store.state.items_company
                                    },
                                    model: {
                                      value: _vm.pa_company,
                                      callback: function($$v) {
                                        _vm.pa_company = $$v
                                      },
                                      expression: "pa_company"
                                    }
                                  }),
                                  _c("m-form-text", {
                                    attrs: {
                                      label: "N° de suivi",
                                      type: "text"
                                    },
                                    model: {
                                      value: _vm.pa_trackingcode,
                                      callback: function($$v) {
                                        _vm.pa_trackingcode = $$v
                                      },
                                      expression: "pa_trackingcode"
                                    }
                                  })
                                ],
                                1
                              )
                        ],
                        1
                      )
                    ])
                  : _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-12 col-lg-6" }, [
                        _c("h4", [_vm._v("Information")]),
                        _c("table", { staticClass: "table table-sm" }, [
                          _c("tbody", [
                            _c("tr", [
                              _c(
                                "td",
                                { staticClass: "text-right no_label_cell" },
                                [_vm._v("Contact :")]
                              ),
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript: void" },
                                    on: { click: _vm.goToContactDetails }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.row_no.co_id.co_invoice_firstname
                                        ) +
                                        " " +
                                        _vm._s(
                                          _vm.row_no.co_id.co_invoice_name
                                        ) +
                                        " "
                                    )
                                  ]
                                ),
                                _c("div", [
                                  _c("small", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.$Utils
                                            .formatPhoneNumber(
                                              _vm.row_no.co_id.co_invoice_tel,
                                              _vm.row_no.co_id
                                                .co_invoice_country
                                            )
                                            .getURI()
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$Utils
                                                .formatPhoneNumber(
                                                  _vm.row_no.co_id
                                                    .co_invoice_tel,
                                                  _vm.row_no.co_id
                                                    .co_invoice_country
                                                )
                                                .formatInternational()
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                ]),
                                _c("div", [
                                  _c("small", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            "mailto:" +
                                            _vm.row_no.co_id.co_invoice_email
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.row_no.co_id.co_invoice_email
                                            ) +
                                            " "
                                        )
                                      ]
                                    )
                                  ])
                                ])
                              ])
                            ]),
                            _c("tr", [
                              _c(
                                "td",
                                { staticClass: "text-right no_label_cell" },
                                [_vm._v("Bénéficiaire :")]
                              ),
                              _c("td", [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "javascript: void" },
                                    on: { click: _vm.goToBoxDetails }
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.row_no.en_id
                                            ? _vm.row_no.en_id.en_fullname
                                            : "---"
                                        ) +
                                        " "
                                    )
                                  ]
                                )
                              ])
                            ]),
                            _c("tr", [
                              _c(
                                "td",
                                { staticClass: "text-right no_label_cell" },
                                [_vm._v(" Statut : ")]
                              ),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.getOrderStatus(_vm.row_no.no_status)
                                    ) +
                                    " "
                                )
                              ])
                            ]),
                            _c("tr", [
                              _c(
                                "td",
                                { staticClass: "text-right no_label_cell" },
                                [_vm._v(" Mis à jour le : ")]
                              ),
                              _c("td", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm
                                        .$moment(_vm.row_no.no_status_date)
                                        .format("DD/MM/YYYY HH:mm")
                                    ) +
                                    " "
                                )
                              ])
                            ])
                          ])
                        ])
                      ]),
                      _c("div", { staticClass: "col-12 col-lg-6" }, [
                        _c("h4", [_vm._v("Suivi de la commande")]),
                        _c("table", { staticClass: "table table-sm" }, [
                          _c(
                            "tbody",
                            _vm._l(_vm.row_no.no_history.list, function(
                              item,
                              index
                            ) {
                              return _c("tr", { key: index }, [
                                _c("td", { staticClass: "no_label_cell" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm
                                          .$moment(item.date)
                                          .format("DD/MM/YYYY HH:mm")
                                      ) +
                                      " "
                                  )
                                ]),
                                _c("td", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.getOrderStatus(item.status)) +
                                      " "
                                  ),
                                  item.comment
                                    ? _c("p", [
                                        _c("i", [
                                          _c("pre", [
                                            _vm._v(_vm._s(item.comment))
                                          ])
                                        ])
                                      ])
                                    : _vm._e()
                                ])
                              ])
                            }),
                            0
                          )
                        ])
                      ])
                    ])
              ]),
              _c("div", { staticClass: "modal-footer" }, [
                _vm.editionMode
                  ? _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.cancelEditStatus }
                        },
                        [_vm._v("Annuler")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ml-2",
                          attrs: { type: "button" },
                          on: { click: _vm.updateStatus }
                        },
                        [_vm._v("Mettre à jour")]
                      )
                    ])
                  : _c("div", [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-secondary",
                          attrs: { type: "button" },
                          on: { click: _vm.cancelWin }
                        },
                        [_vm._v("Fermer")]
                      ),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary ml-2",
                          attrs: { type: "button" },
                          on: { click: _vm.editStatus }
                        },
                        [_vm._v("Modifier")]
                      )
                    ])
              ])
            ])
          ]
        ),
        _c("m-message-dialog", {
          attrs: { title: "Erreur", text: _vm.dialogErrTxt },
          model: {
            value: _vm.dialogErr,
            callback: function($$v) {
              _vm.dialogErr = $$v
            },
            expression: "dialogErr"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }